<template>
  <div class="news-body-div" v-show="news_show" ref="news" :class="{ 'news-move-up': news_Animate }">
    <div class="news-title-div">
      <h4 class="news-title-text banCopy">新闻动态</h4>
    </div>

    <div class="new-title-div col-12">
      <div class="new-content-div col-lg-9 col-12"><!--d-none d-lg-block-->
        <video-player :options="videoOptions" class="gradient col-md-7 col-lg-5 col-9 col-sm-8 new-videoBox" />
        <ul class="list-unstyled new-title-list banCopy col-lg-6 col-10">
          <li class="new-title-list-item transition mouseLink" v-for="item in homeNewsList" :key="item"
            @click="gotoEssay(item.id, item.content, item.title, item.date, item.author)">
            <div class="list-title">
              <h4 class="list-title-text">{{ item.year }}</h4>
              <h6 class="list-title-day title-color">{{ item.day }}</h6>
            </div>

            <div class="new-content">
              <h4 class="new-content-text-link list-title-text">
                {{ item.title }}
              </h4>
              <h6 class="title-color new-content-text">
                {{ item.outline }}
              </h6>
            </div>
          </li>
          <span class="more-text transition hand" @click="gotoNewsList()">查看更多 》</span>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./video.vue";
import { isElementNotInViewport } from "../js/utils.js";
export default {
  name: "VideoExample",
  components: {
    VideoPlayer,
  },
  data() {
    return {
      homeNewsList: [],
      videoOptions: {
        autoplay: false,
        controls: true,
        doubleClick: false,
        PictureInPictureToggle: false,
        // poster:
        //   "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/png/AFWXZMTK12345679_1578909680.png",
        poster: require('@/video/9c08f3745a7123d94aa0781c8d12446.jpg'),
        sources: [
          {
            // src: "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/video/mp4/ABFXZMNTK1345789_1587006872.mp4",
            src: require('@/video/杭开集团宣传片-长版本成片-20240531.mp4'),
            type: "video/mp4",
          },
        ],
        controlBar: {
          timeDivider: false,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
        userActions: {
          doubleClick: false,
        },
      },
      news_Animate: false,
      news_show: false,
    };
  },
  mounted() {
    if (this.homeNewsList.length == 0) {
      this.Post();
    }
    // 监听滚动事件
    window.addEventListener("scroll", this.scrollToTop);
    if (screen.width < 991) {
      this.news_show = true;
    }
  },
  beforeRouteLeave(to, form, next) {
    // 离开路由移除滚动事件
    window.removeEventListener("scroll", this.scrollToTop, true);
    next();
  },
  methods: {
    async Post() {
      var url = "http://demoapi.hkjt.cn/pages/newPager.php";

      await this.axios
        .get(url)
        .then((res) => {
          let resArr = [], num = 0;
          // for(let i=res.data.length-1;i>=0;i--){
          //   resArr[num] = res.data[i];
          //   num++
          // }
          // console.log(res.data)
          this.homeNewsList = res.data
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
    // 滚动事件
    scrollToTop() {
      !isElementNotInViewport(this.$refs.news)
        ? (this.news_Animate = true)
        : "";
      // console.log(this.header_Animate);
      if (screen.width < 991) {
        this.news_Animate = false;
        this.news_show = true;
      } else {
        !isElementNotInViewport(this.$refs.news)
          ? (this.news_Animate = true)
          : "";
        this.news_show = true;
      }
    },
    gotoEssay(id, content, title, date, author) {
      this.$router.push({
        name: "essay",
        query: {
          id: id,
          // content: content,
          // title: title,
          // date: date,
          // author: author,
          type: "news",
        },
      });
    },
    gotoNewsList() {
      this.$router.push({
        name: "newsList",
      });
    },
  },
};
</script>

<style scoped>
.list-title-day {
  font-size: 1.125rem;
  color: rgb(102, 102, 102);
}

.list-title>.list-title-text {
  font-size: 1.5rem;
  color: rgb(102, 102, 102);
}

.news-title-text {
  color: rgba(54, 54, 54, 0.925);
  font-size: 1.5rem;
}

.news-body-div {
  background-color: #fff;
}

.news-title-div {
  text-align: center;
  padding: 3rem 0 3rem 0;
}

@keyframes move-up {
  0% {
    opacity: 0;
    transform: translateY(+500px);
  }

  100% {
    opacity: 1;
  }
}

.news-move-up {
  animation: move-up 1.5s;
}

.more-text {
  display: block;
  text-align: right;
  width: 100%;
  padding-top: 2rem;
  float: right;
  color: #666666;
}

.new-title-div {
  display: flex;
  justify-content: center;
}

.new-content-div {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.new-content {
  margin-left: 0.4rem;
  width: 86%;
}

.new-title-list {
  margin-left: 5rem;
}

.new-title-list-item {
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  height: 7.4rem;
  margin: -1px;
  display: flex;
  align-items: center;
}

.more-text:hover {
  color: #237fef;
}

.new-title-list-item:hover .new-content-text-link {
  color: #237fef;
}

.new-content-text {
  font-size: 0.95rem;
  color: rgba(152, 152, 152, 0.664);
}

.new-content-text-link {
  font-size: 1.125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition-duration: 0.2s;
  color: rgb(54, 54, 54);
}

.list-title {
  border-right: 1px solid #e8e8e8;
  padding-right: 0.4rem;
  white-space: nowrap;
}

.title-color {
  color: #666666;
  letter-spacing: 0.15rem;
}

h4 {
  color: #363636;
}

h6 {
  color: #989899;
}

.new-content-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition-duration: 0.8s;
}

.new-videoBox {
  height: 100% !important;
  /* width: 50%; */
}

.new-videoBox :deep(.vjs-poster) {
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
  background-position: center center;
}

@media screen and (max-width: 991px) {
  .new-videoBox {
    height: 20rem !important;
    /* margin: auto; */
  }

  .new-content-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .new-title-list {
    margin-left: 0;
    /* margin: auto; */
  }

  .title-color {
    font-size: 1rem;
  }

  .list-title-text {
    font-size: 1.3rem;
  }

  .new-title-list-item {
    height: 8rem;
  }

  .more-text {
    padding-top: 1rem;
  }

  .more-link {
    font-size: 0.8rem;
  }
}

@media screen and (max-width: 576px) {
  .new-videoBox {
    height: 15rem !important;
    /* margin: auto; */
  }

  .title-color {
    font-size: 0.6rem;
  }

  .list-title-text {
    font-size: 1rem;
  }

  .new-title-list-item {
    height: 5rem;
  }

  .more-text {
    padding-top: 0.9rem;
  }

  .more-link {
    font-size: 0.7rem;
  }
}
</style>